<style lang="scss"></style>

<template>
  <div id="modal-remove-acabamento" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="acabamento">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de acabamento
                    <span
                      class="text-info"
                    >{{ acabamento.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoAcabamentoService from '../../../services/TipoAcabamentoService';

export default {
  name: 'modal-remove-acabamento',
  data() {
    return {
      enviando: false,
      acabamento: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-acabamento').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeAcabamentoId = null;
    });

    if (this.$parent.removeAcabamentoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.acabamento = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeAcabamentoId === 0) return;

        this.acabamento = await TipoAcabamentoService.findById(
          this.$parent.removeAcabamentoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-acabamento').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoAcabamentoService.remove(this.acabamento.id);

        this.$toast.success('Tipo de acabamento removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-acabamento').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
